import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCategories } from "../../../state/actions/catalogue";
import { useParams } from "react-router-dom";
import { DotsLoader } from "../../../components/ui/Loader/dotsLoader";
import CategoryAllBotsView from "./Categories/CategoryAllBotsView";
import CatalogCategoriesView from "./Categories/CatalogCategoriesView";
import { setLoader } from "../../../state/actions/loader";


const CatalogCategoriesContainer = () => {
	const dispatch = useDispatch();
	const { id } = useParams();
	console.log()

	useEffect(() => {
		dispatch(setLoader(true));
		dispatch(fetchCategories());
	}, [dispatch]);

	const categories = useSelector((state) => state.catalogue.categories);
	const selectedDomain = useSelector((state) => state.domain);
	const isLoading = useSelector((state) => state.loader.loading);
	const userDomain = selectedDomain?.userDomain || "";

	if (isLoading) {
		return <DotsLoader />
	}

	if (id) {
		return (
			<CategoryAllBotsView
				category={id}
				bots={categories?.[id] || []}
				userDomain={userDomain}
			/>
		);
	}

	return <CatalogCategoriesView categories={categories} userDomain={userDomain} />;
};

export default CatalogCategoriesContainer;
